/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsTeamDetailViewProps } from "../../../modules/hosports-team-detail/./hosports-team-detail";
//@ts-ignore
import { MobileBreakpoint, ModelYear, GeneralAssetUrl} from "./../utilities/constants";
import Hero from "./../../../baseComponents/hero/./hero";

/**
 *
 * Hero component
 * @extends {React.Component<IHosportsTeamDetailViewProps<>}
 */
class HosportsTeamDetail extends React.Component<IHosportsTeamDetailViewProps> {
  public render(): JSX.Element {
    const { config } = this.props;
    const {
      firstName,
      lastName,
      quote,
      headline,
      description,
      hometown,
      highlights,
      facebookLink,
      instagramLink,
      youtubeLink,
      thumbnail,
      banner,
    } = config;
    let bannerImage = banner;
    console.log(config)
    console.log(bannerImage)
    return (
      <div className="team-detail-wrapper">
        <div className="light-grey-background">
          <Hero
            preTitle={'Pro Team'}
            title={firstName + " " + lastName}
            backgroundImage={bannerImage ? bannerImage.src : undefined}
            height="threeQuarter"
            theme="dark"
            backgroundTint = "medium"
            textPlacement="leftCenter"
          />
          <div className="row primary-background small-bottom-padding">
            <div className="hide-for-small medium-1 large-2">
              <div
                className="medium-padding white-background"
                style={{ paddingLeft: "0px", paddingRight: "0px" }}
              >
                <div
                  style={{ height: "2px", marginTop: "8px", width: "110%" }}
                  className="primary-background full-width"
                ></div>
              </div>
            </div>
            <div className="small-12 medium-6 large-6 small-padding">
              {headline && <h6 className="headline-outer">
                <b>
                  <span className="uppercase subheading">{headline}</span>
                </b>
              </h6>}
              {quote && <h2 className="quote-outer">{quote}</h2>}
              {description && <p className="subheading small-top-margin">{description}</p>}
            </div>
            <div className="hide-for-small medium-1">&nbsp;</div>
            <div className="team-overlap small-12 medium-3 large-2 black-background centered-text">
              <div className="tiny-padding no-bottom-padding">
                {thumbnail &&
                  <div className="centered-text full-width">
                    <div className="headshot circle half-width background-image-fill" style={{backgroundImage:"url("+thumbnail.src+")", margin:"auto", marginBottom:"20px"}}>
                      <img className="full-width" src={GeneralAssetUrl+'square.png'} />
                    </div>
                  </div>
                }
                <p className="white">
                  <b>
                    {firstName} {lastName}
                  </b>
                </p>
                {facebookLink && <a target="_blank" href={facebookLink}>
                  <img
                    className="team-social-icon"
                    src={GeneralAssetUrl+'facebook-icon.png'}
                  />
                </a>}
                {instagramLink && <a target="_blank" href={instagramLink}>
                  <img
                    className="team-social-icon"
                    src={GeneralAssetUrl+'instagram-icon.png'}
                  />
                </a>}
                {youtubeLink && <a target="_blank" href={youtubeLink}>
                  <img
                    className="team-social-icon"
                    src={GeneralAssetUrl+'youtube-icon.png'}
                  />
                </a>}
              </div>
              {hometown && <div
                className="small-padding border-bottom"
                style={{ borderBottom: "1px solid rgba(255,255,255, 0.15)" }}
              >
                <h6 className="white subheading uppercase">{"Hometown"}</h6>
                <p className="white no-margin">{hometown}</p>
              </div>}
              {highlights &&
                highlights.map((data: any) => {
                  return (
                    <div
                      className="tiny-padding border-bottom"
                      style={{borderBottom: "1px solid rgba(255,255,255, 0.15)"}}
                    >
                      <h6 className="white subheading uppercase">{data.Key}</h6>
                      <p className="white no-margin">{data.Value}</p>
                    </div>
                  );
                })}
            </div>
            <div className="hide-for-small medium-1 large-1 white-background">
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default HosportsTeamDetail;
